import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { Box, Grid, Slider, Typography, styled } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useContext, useState } from "react";

import { MemoizedButton } from "../../SDK/button";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import { sendAnalytics } from "../../utils/analyticsCommon";
import { createCookieInHour } from "../../utils/cookie";
import TCOCard from "./tcoCard";

const CustomTCOMain = styled(Box)(({ theme }) => ({
  ".MuiSlider-markLabel": {
    fontWeight: "600",
  },
  // ".MuiSlider-mark": {
  //   display: "none",
  // },
  ".MuiSlider-root": {
    paddingTop: "0px",
    paddingBottom: "10px",
  },
  // ".slider-box": {
  //   position: "relative",
  // },
  [theme.breakpoints.down("md")]: {
    // ".slider-box": {
    //   position: "fixed",
    // },
  },
}));

const TCOMain = ({ x, setX }) => {
  const yearsList = [
    {
      value: 3,
      label: "3 years",
    },
    {
      value: 4,
      label: "4 years",
    },
    {
      value: 5,
      label: "5 years",
    },
  ];
  const kmList = [
    {
      value: "60",
    },
    {
      value: "80",
    },
    {
      value: "100",
    },
    {
      value: "120",
    },
    {
      value: "140",
    },
    {
      value: "160",
    },
    {
      value: "180",
    },
  ];
  const [fuelType, setFuelType] = useState("diesel");
  const [kms, setKms] = useState(60);
  const [years, setYears] = useState(3);

  const evBasePricesobj = {
    onRoadPrices: 382000,
    fuelCost: 225 * years * kms,
    maintenance: 2500 * years + 6 * years * (kms - 20),
    resale: 160000 - 50 * (kms - 20),
    subsidy: 80000,
    exShowRoomPrice: 361696,
  };
  const otherPricesobj = {
    onRoadPrices: 312000,
    fuelCost: 950 * years * kms,
    maintenance: 16000 * years + 48 * years * (kms - 20),
    resale: 180000 - 50 * (kms - 20),
    subsidy: 0,
    exShowRoomPrice: 288179,
  };
  const [evPrices, setEVPrices] = useState(evBasePricesobj);
  const [otherPrices, setOtherPrices] = useState(otherPricesobj);
  const { showFormPopup } = useContext(Context);

  const valueKilometers = (value) => {
    return `${value}°C`;
  };

  const valueYears = (value) => {
    return `${value}°C`;
  };

  const valueLabelFormat = (value) => {
    return yearsList.findIndex((year) => year.value === value) + 3;
  };

  const handleEVPrices = (years, kms) => {
    let x = 160000 - 50 * (kms - 20);
    if (years === 4) x = 120000 - 55 * (kms - 20);
    else if (years === 5) x = 70000 - 60 * (kms - 20);
    let obj = {
      ...evPrices,
      fuelCost: 225 * years * kms,
      maintenance: 2500 * years + 6 * years * (kms - 20),
      resale: x,
    };
    setEVPrices(obj);
  };
  const handleOtherPrices = (fuelType, years, kms) => {
    if (fuelType === "cng") {
      let x = 150000 - 50 * (kms - 20);
      if (years === 4) x = 105000 - 55 * (kms - 20);
      else if (years === 5) x = 65000 - 60 * (kms - 20);
      let obj = {
        onRoadPrices: 312000,
        subsidy: 0,
        exShowRoomPrice: 288179,
        fuelCost: 663 * years * kms,
        maintenance: 16000 * years + 48 * years * (kms - 20),
        resale: x,
      };
      setOtherPrices(obj);
    } else {
      let x = 180000 - 50 * (kms - 20);
      if (years === 4) x = 131000 - 55 * (kms - 20);
      else if (years === 5) x = 81000 - 60 * (kms - 20);
      let obj = {
        onRoadPrices: 340200,
        subsidy: 0,
        exShowRoomPrice: 314976,
        fuelCost: 950 * years * kms,
        maintenance: 16000 * years + 48 * years * (kms - 20),
        resale: x,
      };
      setOtherPrices(obj);
    }
  };
  const handleChange = (event) => {
    let payload = {
      initial_vehicle_type: fuelType,
      switched_vehicle_type: event.target.value,
    };
    sendAnalytics("vehicle_type_switched", payload, "en");
    setFuelType(event.target.value);
    handleOtherPrices(event.target.value, years, kms);
  };

  return (
    <CustomTCOMain>
      <Box style={{ margin: "20px" }}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Box style={{ display: "block" }}>
            <Typography style={{ fontSize: "20px", fontWeight: "600" }}>
              Ownership Cost
            </Typography>
            <Typography style={{ fontSize: "12px", fontWeight: "700" }}>
              ({years} year)
            </Typography>
          </Box>

          <Box>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={fuelType}
              onChange={handleChange}
              style={{ width: "140px" }}
            >
              <MenuItem value={"cng"}>CNG</MenuItem>
              <MenuItem value={"diesel"}>Diesel</MenuItem>
            </Select>
          </Box>
        </Box>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={6} style={{ display: "block" }}>
              <TCOCard
                mainColor="#35BF68"
                secondaryColor="#B5E9C8"
                imageName="electricVehicle"
                vehicleType="Turno Electric Vehicle"
                prices={evPrices}
                kms={kms}
                years={years}
              />
            </Grid>
            <Grid item xs={6} style={{ display: "block" }}>
              <TCOCard
                mainColor={fuelType === "cng" ? "#CBA62F" : "#D48237"}
                secondaryColor={fuelType === "cng" ? "#FFF4D0" : "#FFCEA0"}
                imageName={fuelType === "cng" ? "cngVehicle" : "dieselVehicle"}
                vehicleType={fuelType === "cng" ? "CNG" : "Diesel"}
                prices={otherPrices}
                kms={kms}
                years={years}
              />
            </Grid>
          </Grid>
        </Box>

        <Box>
          <MemoizedButton
            content={"Book Vehicle"}
            sx={{
              margin: "10px 0px 5px 0px",
              background: "#35BF68",
              boxShadow: "0px 4px 0px #177138",
              width: "100%",
              background: primary.main,
              boxShadow: "none",
              border: "2px solid #E8345E",
              borderRadius: "4px",
              padding: "12px 8px",
              fontSize: "16px",
              color: "white",
              "&:hover": {
                background: primary.main,
                border: "none",
                color: "white",
                boxShadow: "none",
              },
            }}
            endIcon={
              <DoubleArrowIcon
                sx={{
                  color: "#ffffff",
                  marginRight: "2px",
                }}
              />
            }
            handleClick={() => {
              showFormPopup("Book Vehicle");
              createCookieInHour("lead_trigger", "tco", 10);
              let payload = {
                selectedYears: years,
                selectedKms: kms,
              };
              sendAnalytics("tco_book_vehicle_clicked", {}, "en");
            }}
          />
        </Box>

        <Box>
          <Typography
            style={{ textAlign: "center", color: "#666666", fontSize: "10px" }}
          >
            *Prices are indicative and may vary by location
          </Typography>
        </Box>

        {/* Slider Component */}
        <Box
          id="slider-component"
          style={{
            background: "#ffffff",
            // margin: "20px 0px",
            boxShadow: `0px -2px 10px rgba(232, 52, 94, 0.2)`,
            paddingTop: "10px",
            position: x,
            bottom: "0px",
            width: "100%",
            left: "0px",
            zIndex: "99",
          }}
          className="slider-box"
        >
          <Box style={{ margin: "0px 30px" }}>
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography style={{ fontSize: "12px", fontWeight: "600" }}>
                Enter Daily kms{" "}
              </Typography>
              <Typography style={{ fontSize: "18px", fontWeight: "800" }}>
                {kms} km
              </Typography>
            </Box>

            <Slider
              aria-label="Kilometers"
              defaultValue={60}
              getAriaValueText={valueKilometers}
              valueLabelDisplay="auto"
              step={null}
              marks={kmList}
              min={40}
              max={180}
              style={{ height: "8px" }}
              onChange={(value) => {
                let selectedKms = value.target.value;
                let payload = { switched_km: selectedKms, initial_km: kms };
                sendAnalytics("tco_km_input_switched", payload, "en");
                setKms(selectedKms);
                handleEVPrices(years, selectedKms);
                handleOtherPrices(fuelType, years, selectedKms);
              }}
            />
          </Box>
          <Box style={{ margin: "0px 30px", paddingBottom: "25px" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography style={{ fontSize: "12px", fontWeight: "600" }}>
                Years{" "}
              </Typography>
            </Box>

            <Slider
              aria-label="Years"
              defaultValue={3}
              getAriaValueText={valueYears}
              valueLabelDisplay="auto"
              marks={yearsList}
              min={2}
              max={5}
              step={null}
              style={{ height: "8px" }}
              onChange={(value) => {
                let selectedYears = value.target.value;
                let payload = {
                  switched_year: selectedYears,
                  initial_year: years,
                };
                sendAnalytics("tco_year_input_switched", payload, "en");
                setYears(selectedYears);
                handleEVPrices(selectedYears, kms);
                handleOtherPrices(fuelType, selectedYears, kms);
              }}
              valueLabelFormat={valueLabelFormat}
            />
          </Box>
        </Box>
      </Box>
    </CustomTCOMain>
  );
};

export default TCOMain;
